//import saga helpers
import { takeEvery, put, all, fork, call } from "redux-saga/effects";

//import actionsType
import {
  CONTACT_PERSON_SINGLE_COMPANY_SEARCH,
  CREATE_CONTACT_PERSON,
  GET_SINGLE_PERSON_CONTACT_DETAILS,
  DELETE_CONTACT_PERSON,
  UPDATE_CONTACT_PERSON,
  DELETE_CONTACT_PERSON_RELATIONSHIP,
  CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH,
  CONTACT_PERSON_TO_EMAIL_INBOUND_DATA,
  CONTACT_PERSON_DATA,
  CONTACT_PERSON_LIST,
  SEARCH_PERSON_WITH_CUSTOMER_ID,
  CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH,
} from "./actionType";

//import action
import {
  contactPersonSingleCompanySearchSuccess,
  contactPersonSingleCompanySearchFailure,
  createContactPersonSuccess,
  createContactPersonFailure,
  getSinglePersonContactDetailsSuccess,
  getSinglePersonContactDetailsFailure,
  deleteContactPersonSuccess,
  deleteContactPersonFailure,
  updateContactPersonSuccess,
  updateContactPersonFailure,
  deleteContactPersonRelationshipSuccess,
  deleteContactPersonRelationshipFailure,
  contactPersonToEmailInboundSearchSuccess,
  contactPersonToEmailInboundSearchFailure,
  contactPersonToEmailInboundDataSuccess,
  contactPersonToEmailInboundDataFailure,
  contactPersonDataSuccess,
  contactPersonDataFailure,
  contactPersonListSuccess,
  contactPersonListFailure,
  searchPersonWithCustomerIdSuccess,
  searchPersonWithCustomerIdFailure,
  customerToContactPersonRelationshipSearchSuccess,
  customerToContactPersonRelationshipSearchFailure,
} from "./action";

//import api
import {
  getSingleCompanySearchPeopleListApiCall,
  createContactPersonApiCall,
  getSinglePersonContactDetailsApiCall,
  deleteContactPersonApiCall,
  updateContactPersonApiCall,
  deleteContactPersonRelationshipApiCall,
  contactPersonToEmailInboundSearchAPICall,
  contactPersonToEmailInboundDataAPICall,
  contactPersonDataAPICall,
  contactPersonListAPICall,
  searchPersonWithCustomerIdAPICall,
} from "../../helpers/fakebackend_helper.js";

function* contactPersonSingleCompanySearchSaga(action) {
  try {
    const response = yield call(
      getSingleCompanySearchPeopleListApiCall,
      action.id
    );
    yield put(contactPersonSingleCompanySearchSuccess(response));
  } catch (error) {
    yield put(contactPersonSingleCompanySearchFailure(error));
  }
}

export function* watchContactPersonSingleCompanySearchSaga() {
  yield takeEvery(
    CONTACT_PERSON_SINGLE_COMPANY_SEARCH,
    contactPersonSingleCompanySearchSaga
  );
}
// Create Contact Person

function* createContactPersonSaga(action) {
  try {
    const response = yield call(createContactPersonApiCall, action.data);
    yield put(createContactPersonSuccess(response));
  } catch (error) {
    yield put(createContactPersonFailure(error));
  }
}

export function* watchCreateContactPersonSaga() {
  yield takeEvery(CREATE_CONTACT_PERSON, createContactPersonSaga);
}

// Get Single Person Contact Details

function* getSinglePersonContactDetailsSaga(action) {
  try {
    const response = yield call(
      getSinglePersonContactDetailsApiCall,
      action.id
    );
    yield put(getSinglePersonContactDetailsSuccess(response));
  } catch (error) {
    yield put(getSinglePersonContactDetailsFailure(error));
  }
}

export function* watchGetSinglePersonContactDetailsSaga() {
  yield takeEvery(
    GET_SINGLE_PERSON_CONTACT_DETAILS,
    getSinglePersonContactDetailsSaga
  );
}

// Delete Contact Person

function* deleteContactPersonSaga(action) {
  try {
    const response = yield call(deleteContactPersonApiCall, action.id);
    yield put(deleteContactPersonSuccess(response));
  } catch (error) {
    yield put(deleteContactPersonFailure(error));
  }
}

export function* watchDeleteContactPersonSaga() {
  yield takeEvery(DELETE_CONTACT_PERSON, deleteContactPersonSaga);
}

// Update Contact Person
function* updateContactPersonSaga(action) {
  try {
    const response = yield call(updateContactPersonApiCall, action.data);
    yield put(updateContactPersonSuccess(response));
  } catch (error) {
    yield put(updateContactPersonFailure(error));
  }
}

export function* watchUpdateContactPersonSaga() {
  yield takeEvery(UPDATE_CONTACT_PERSON, updateContactPersonSaga);
}

// Delete Contact Person Relationship

function* deleteContactPersonRelationshipSaga(action) {
  try {
    const response = yield call(
      deleteContactPersonRelationshipApiCall,
      action.id
    );
    yield put(deleteContactPersonRelationshipSuccess(response));
  } catch (error) {
    yield put(deleteContactPersonRelationshipFailure(error));
  }
}

export function* watchDeleteContactPersonRelationshipSaga() {
  yield takeEvery(
    DELETE_CONTACT_PERSON_RELATIONSHIP,
    deleteContactPersonRelationshipSaga
  );
}

// Contact Person To Email Inbound Search

function* contactPersonToEmailInboundSearchSaga(action) {
  try {
    const response = yield call(
      contactPersonToEmailInboundSearchAPICall,
      action.data
    );
    yield put(contactPersonToEmailInboundSearchSuccess(response));
  } catch (error) {
    yield put(contactPersonToEmailInboundSearchFailure(error));
  }
}

export function* watchContactPersonToEmailInboundSearchSaga() {
  yield takeEvery(
    CONTACT_PERSON_TO_EMAIL_INBOUND_SEARCH,
    contactPersonToEmailInboundSearchSaga
  );
}

// Contact Person To Email Inbound Data

function* contactPersonToEmailInboundDataSaga(action) {
  try {
    const response = yield call(
      contactPersonToEmailInboundDataAPICall,
      action.data
    );
    yield put(contactPersonToEmailInboundDataSuccess(response));
  } catch (error) {
    yield put(contactPersonToEmailInboundDataFailure(error));
  }
}

export function* watchContactPersonToEmailInboundDataSaga() {
  yield takeEvery(
    CONTACT_PERSON_TO_EMAIL_INBOUND_DATA,
    contactPersonToEmailInboundDataSaga
  );
}

// Contact Person Data

function* contactPersonDataSaga(action) {
  try {
    const response = yield call(contactPersonDataAPICall, action.payload);
    yield put(contactPersonDataSuccess(response));
  } catch (error) {
    yield put(contactPersonDataFailure(error));
  }
}

export function* watchContactPersonDataSaga() {
  yield takeEvery(CONTACT_PERSON_DATA, contactPersonDataSaga);
}

// Contact Person List

function* contactPersonListSaga(action) {
  try {
    const response = yield call(contactPersonListAPICall, action.data);
    yield put(contactPersonListSuccess(response));
  } catch (error) {
    yield put(contactPersonListFailure(error));
  }
}

export function* watchContactPersonListSaga() {
  yield takeEvery(CONTACT_PERSON_LIST, contactPersonListSaga);
}

// Search Person With Customer Id

function* searchPersonWithCustomerIdSaga(action) {
  try {
    const response = yield call(
      getSingleCompanySearchPeopleListApiCall,
      action.payload
    );
    yield put(searchPersonWithCustomerIdSuccess(response));
  } catch (error) {
    yield put(searchPersonWithCustomerIdFailure(error));
  }
}

export function* watchSearchPersonWithCustomerIdSaga() {
  yield takeEvery(
    SEARCH_PERSON_WITH_CUSTOMER_ID,
    searchPersonWithCustomerIdSaga
  );
}

// Customer To Contact Person Relationship Search

function* customerToContactPersonRelationshipSearchSaga(action) {
  try {
    const response = yield call(
      searchPersonWithCustomerIdAPICall,
      action.payload
    );
    console.log("response", response);
    yield put(customerToContactPersonRelationshipSearchSuccess(response));
  } catch (error) {
    yield put(customerToContactPersonRelationshipSearchFailure(error));
  }
}

export function* watchCustomerToContactPersonRelationshipSearchSaga() {
  yield takeEvery(
    CUSTOMER_TO_CONTACT_PERSON_RELATIONSHIP_SEARCH,
    customerToContactPersonRelationshipSearchSaga
  );
}
export default function* People() {
  yield all([
    fork(watchContactPersonSingleCompanySearchSaga),
    fork(watchCreateContactPersonSaga),
    fork(watchGetSinglePersonContactDetailsSaga),
    fork(watchDeleteContactPersonSaga),
    fork(watchUpdateContactPersonSaga),
    fork(watchDeleteContactPersonRelationshipSaga),
    fork(watchContactPersonToEmailInboundSearchSaga),
    fork(watchContactPersonToEmailInboundDataSaga),
    fork(watchContactPersonDataSaga),
    fork(watchContactPersonListSaga),
    fork(watchSearchPersonWithCustomerIdSaga),
    fork(watchCustomerToContactPersonRelationshipSearchSaga),
  ]);
}
